import React from 'react';
import { Link, withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  root: {
    flexGrow: 1,
  },
  form: {
    height: 240,
    marginTop: theme.spacing.unit * 10,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    height: '100%',
    color: theme.palette.text.secondary,
  },
  control: {
    padding: theme.spacing.unit * 2,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 250,
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing.unit * 5,
  },
});


@inject("authStore", "commonStore")
@withRouter
@observer
class PasswordChange extends React.Component {
  state = {
    noMatch: false
  }
  handlePasswordChange = e => this.props.authStore.setPassword(e.target.value);
  handleConfirmPasswordChange = e => this.props.authStore.setConfirmPassword(e.target.value);
  handleSubmitForm = e => {
    e.preventDefault();
    const { values } = this.props.authStore
    const { password, confirmPassword } = values

    if(password === confirmPassword){
      this.setState({noMatch: false})
      this.props.authStore.createNewPassword().then(() => {
        this.props.history.replace("/")
        window.location.reload();
       });
    }else{
       this.setState({noMatch: true})
    }


  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  }

  render() {
    const { noMatch } = this.state
    const { classes, authStore, commonStore } = this.props;
    const { values, inProgress } = authStore;
    const { signInError } = commonStore

    return (
      <div>
      <Typography color="error">{signInError.message}</Typography>
      <Grid container className={classes.root}>
      <Grid
      container
      className={classes.form}
      alignItems={'center'}
      direction={'row'}
      justify={'center'}
    >
      <Paper className={classes.control}>
      <Typography color="error">{signInError.message}</Typography>
      <form className={classes.container} noValidate autoComplete="off">  
      <Grid
      container
      alignItems={'center'}
      direction={'column'}
      justify={'center'}
    >
        <TextField
        id="password-input"
        label="New Password"
        className={classes.textField}
        type="password"
        autoComplete="current-password"
        margin="normal"
        onChange={this.handlePasswordChange}
      />
        <TextField
        error={noMatch}
        id="password-input2"
        label="Confirm Password"
        className={classes.textField}
        type="password"
        margin="normal"
        onChange={this.handleConfirmPasswordChange}
      />
      <Button onClick={this.handleSubmitForm} variant="contained" color="primary" className={classes.button}>
        Confirm New Password
      </Button>
      </Grid>
    </form>

      </Paper>
      </Grid>
      </Grid>
      </div>
      


      
    );
  }
}




PasswordChange.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PasswordChange);


/*import { Link, withRouter } from "react-router-dom";
import BasicPage from "../lib/BasicPage";
import React from "react";
import { inject, observer } from "mobx-react";
import { FormGroup, FormControl, Button } from "react-bootstrap";

@inject("authStore")
@withRouter
@observer
export default class PasswordChange extends React.Component {
  handlePasswordChange = e => this.props.authStore.setPassword(e.target.value);
  handleConfirmPasswordChange = e => this.props.authStore.setConfirmPassword(e.target.value);
  handleSubmitForm = e => {
    e.preventDefault();
    this.props.authStore.createNewPassword().then(() => {
      this.props.history.replace("/")
    });
  };

  render() {
    const { values, inProgress } = this.props.authStore;

    return (
      <BasicPage title="Change Password">
        <p>
          <Link to="login">Cancel?</Link>
        </p>
        <p>
          Please create a new password before completing your sign in.
        </p>
        <form onSubmit={this.handleSubmitForm}>

          <FormGroup>
          <FormControl
            type="password"
            placeholder="New Password"
            onChange={this.handlePasswordChange}
          />
        </FormGroup>

          <FormGroup>
            <FormControl
              type="password"
              placeholder="Confirm Password"
              onChange={this.handleConfirmPasswordChange}
            />
          </FormGroup>

          <Button
            bsSize="large"
            bsStyle="primary"
            type="submit"
            disabled={inProgress}
          >
            Create New
          </Button>
        </form>
      </BasicPage>
    );
  }
}
*/


// WEBPACK FOOTER //
// ./src/components/Account/ConfirmPassword.js